import 'css-chunksrc/client/scenes/workloads/wbs/resource/styles.scss';export default {
  "resource": "_resource_p6hdn_1",
  "name": "_name_p6hdn_7",
  "affiliation": "_affiliation_p6hdn_18",
  "avatar": "_avatar_p6hdn_29",
  "iconBox": "_iconBox_p6hdn_34"
};